export const channelButtonWrapper = {
    alignItems: 'center',
    display: 'flex',
    gap: '10px',
}

export const dropdownContentWrapper = {'> button': {width: '100%'}}

export const desktopWrapper = {overflow: 'hidden'}
